export enum YesNoOption {
  YES = 'Yes',
  NO = 'No',
}
